import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import ReactDatatable from "@ashvin27/react-datatable";
import ApiConnect from "../../../Utils/ApiConnect";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import {
  RestaurantTableList,
  RestaurantTableGroup,
} from "../../../redux/actions/Modules.Action";
import CryptoJS from "react-native-crypto-js";
import { QRCode } from "react-qrcode-logo";
import { CopyToClipboard } from "react-copy-to-clipboard";
class Tables extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      formError: false,
      data: [],
      btnDisable: false,
    };
    this.columns = [
      {
        key: "name",
        text: "Table Name",
        sortable: true,
      },
      {
        key: "capacity",
        text: "Table Capacity",
      },
      {
        key: "group",
        text: "Table Group",
      },
      {
        key: "id",
        text: "Table QR",
        cell: (record) => {
          let ciphertext = CryptoJS.AES.encrypt(
            JSON.stringify(record.name),
            process.env.REACT_APP_API_KEY
          ).toString();
          return (
            <CopyToClipboard text={ciphertext}>
              <div
                className="d-flex d-inline"
                onClick={() => this.handleCopy(record.name)}
              >
                <QRCode
                  value={ciphertext}
                  size="80"
                  alt={ciphertext}
                  qrStyle="dots"
                  eyeRadius={80}
                  ecLevel="Q"
                />
              </div>
            </CopyToClipboard>
          );
        },
      },
      {
        key: "id",
        text: "Customer QR",
        cell: (record) => {
          let data = `https://narayaniconcept.com/${process.env.REACT_APP_THEME}/Order/${process.env.REACT_APP_COMPANY}/${this.props.userData.company}/${record.name}`;
          return (
            <CopyToClipboard text={data}>
              <div
                className="d-flex d-inline"
                onClick={() => this.handleCopy(record.name)}
              >
                <QRCode
                  value={data}
                  size="80"
                  alt={data}
                  qrStyle="dots"
                  eyeRadius={80}
                  ecLevel="Q"
                />
              </div>
            </CopyToClipboard>
          );
        },
      },
      {
        key: "action",
        text: "Action",
        className: "table-actions",
        width: 150,
        sortable: false,
        align: "center",
        cell: (record) => {
          return (
            <React.Fragment>
              <button className="table-action btn btn-square btn-pure hover-warning">
                <span className="material-icons-outlined">edit_note</span>
              </button>
              <button className="table-action btn btn-square btn-pure hover-danger">
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 10,
      length_menu: [10, 20, 50],
      show_filter: true,
      show_pagination: true,
      button: {
        // excel: true,
        // print: true
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  componentDidMount() {
    this.fetchTableData();
    this.fetchTableGroup();
  }
  handleChange(e) {
    const Ndata = { ...this.state.data };
    Ndata[e.target.name] = e.target.value;
    this.setState({ data: Ndata });
  }
  fetchTableData() {
    ApiConnect.get("/POS/Restaurant/TableList")
      .then((response) => {
        this.props.RestaurantTableList(response.data);
      })
      .catch((error) => console.log(error));
  }
  fetchTableGroup() {
    ApiConnect.get("/POS/Restaurant/TableGroup")
      .then((response) => {
        this.props.RestaurantTableGroup(response.data);
      })
      .catch((error) => console.log(error));
  }
  createNewTable(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    const Fdata = new FormData();
    Fdata.append("name", this.state.data.name);
    Fdata.append("group", this.state.data.group);
    Fdata.append("capacity", this.state.data.capacity);
    ApiConnect({
      method: "post",
      url: "/POS/Restaurant/NewTable",
      data: Fdata,
    }).then((response) => {
      this.setState({ btnDisable: false });
      if (response.data.status === 201) {
        toast.success(response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });
        this.setState({ data: [], showModal: false, formError: false });
        this.fetchTableData();
      } else if (response.data.status === 406) {
        this.setState({ formError: response.data.message });
      } else {
        toast.error(`${response.data.message} Or Table might already exist.`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });
      }
    });
  }
  handleCopy(e) {
    toast.success(`Table No ${e} QR Copied`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      draggableDirection: "y",
    });
  }
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Table List</strong>
                  <small className="subtitle">Click to copy QR Message.</small>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <ReactDatatable
                className="table table-separated"
                config={this.config}
                records={this.props.TableList}
                columns={this.columns}
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">Add New Table</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span>×</span>
                </button>
              </Modal.Header>
              <form onSubmit={(e) => this.createNewTable(e)}>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Table Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        onChange={(e) => this.handleChange(e)}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Table Group</label>
                      <label className="col-12">
                        <select
                          className="form-control"
                          name="group"
                          onChange={(e) => this.handleChange(e)}
                        >
                          <option>Select Group</option>
                          {this.props.TableGroup.map((group, index) => (
                            <option value={group.id} key={`${group}${index}`}>
                              {group.name}
                            </option>
                          ))}
                        </select>
                      </label>
                    </div>
                  </div>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Table Capacity</label>
                      <label className="col-12">
                        <input
                          onChange={(e) => this.handleChange(e)}
                          type="text"
                          className="form-control"
                          name="capacity"
                          required="required"
                        />
                      </label>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={this.state.btnDisable}
                  >
                    Create
                  </button>
                </Modal.Footer>
              </form>
            </Modal.Dialog>
          </Modal>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    TableList: state.Restaurant.TableList,
    TableGroup: state.Restaurant.TableGroup,
    userData: state.Auth.userData,
  }),
  {
    RestaurantTableList,
    RestaurantTableGroup,
  }
)(Tables);
